import React from 'react';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../../components/InputFilterItem';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export interface FilterOptions {
  originalZipcode?: string;
  originalState?: string;
  originalCity?: string;
  originalFullAddress?: string;
}

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  originalZipcode: undefined,
  originalState: undefined,
  originalCity: undefined,
  originalFullAddress: undefined,
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (filters: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const handleChange = (key: keyof FilterOptions, value: string | undefined) => {
    const processed = typeof value === 'string' && value.trim() === '' ? undefined : value;
    setFilters({ ...filters, [key]: processed });
  };

  const columnLabels = [
    t('mapTool.addressWhitelist.filters.zipcode'),
    t('mapTool.addressWhitelist.filters.state'),
    t('mapTool.addressWhitelist.filters.city'),
    t('mapTool.addressWhitelist.filters.fullAddress'),
  ];
  const labelClassName = getSmartLabelClassName(columnLabels);

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelist.filters.zipcode')}
            value={filters.originalZipcode ?? ''}
            onChange={(e) => handleChange('originalZipcode', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelist.filters.state')}
            value={filters.originalState ?? ''}
            onChange={(e) => handleChange('originalState', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelist.filters.city')}
            value={filters.originalCity ?? ''}
            onChange={(e) => handleChange('originalCity', e.target.value)}
            spanClassName={labelClassName}
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('mapTool.addressWhitelist.filters.fullAddress')}
            value={filters.originalFullAddress ?? ''}
            onChange={(e) => handleChange('originalFullAddress', e.target.value)}
            spanClassName={labelClassName}
            placeholder={t('mapTool.addressWhitelist.placeholders.fullAddressFuzzy') as string}
          />
        </div>
      </div>
    </div>
  );
};

export default FilterArea;
